import React, { Component } from 'react'
import { HOST } from '../../config';
import './Left_side.css'

export default class LeftSide extends Component {
    constructor(props) {
        super(props);
        this.id = localStorage.getItem("id");
    }

    Select_menu = (selected_menu) => {
        this.props.Select_menu(selected_menu)
    }

    render() {
        return (
            <div className='Left_side_container' >
                {this.props.User_role == 'Составитель' ? <div onClick={() => this.Select_menu(1)}
                    className={this.props.selected_menu === 1 ? 'activ' : null}>
                    <i className="far fa-calendar-alt"></i>
                    <h4>Табель</h4>
                </div> : null}

                {this.props.is_admin > 0 ?
                    <div onClick={() => this.Select_menu(3)}
                        className={this.props.selected_menu === 3 ? 'activ' : null}>
                        <i className="fas fa-users-cog"></i>
                        <h4>Составители</h4>
                    </div> : null}
                {this.props.is_admin > 0 ?
                    <div onClick={() => this.Select_menu(4)}
                        className={this.props.selected_menu === 4 ? 'activ' : null}>
                        <i className="fas fa-user-tie"></i>
                        <h4>Руководители</h4>
                    </div> : null}
                {this.props.is_admin > 0 ?
                    <div onClick={() => this.Select_menu(2)}
                        className={this.props.selected_menu === 2 ? 'activ' : null}>
                        <i className="fas fa-user-edit"></i>
                        <h4>Должности</h4>
                    </div> : null}
                {this.props.is_admin > 0 ?
                    <div onClick={() => this.Select_menu(8)}
                        className={this.props.selected_menu === 8 ? 'activ' : null}>
                        <i className="far fa-calendar-alt"></i>
                        <h4>Праздники</h4>
                    </div> : null}

                {this.props.User_role == 'Составитель' ? <div onClick={() => this.Select_menu(5)}
                    className={this.props.selected_menu === 5 ? 'activ' : null}>
                    <i className="far fa-file-pdf"></i>
                    <h4>Отчеты</h4>
                </div> : null}

                {this.props.User_role == 'Руководитель' ? <div onClick={() => this.Select_menu(6)}
                    className={this.props.selected_menu === 6 ? 'activ' : null}>
                    <i className="fas fa-file-signature"></i>
                    <h4>Документы на подтверждение</h4>
                </div> : null}

                {this.props.Timesheet_report == 1 ? <div onClick={() => this.Select_menu(7)}
                    className={this.props.selected_menu === 7 ? 'activ' : null}>
                    <i className="far fa-file-pdf"></i>
                    <h4>Бухгалтерия</h4>
                </div> : null}

                <a href='https://www.youtube.com'
                    target="_blank"
                    rel="noreferrer"
                    className="Rukovodstvo"> <i className="fab fa-youtube"></i>Руководство для пользователя</a>
            </div>
        )
    }
}
